import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const RsvtiTasksReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                tasks:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.TASKS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, tasks: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_TASKS:
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, tasks: action.payload};

        case ActionTypes.TASKS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.ADD_TASK:
            const nTask = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, tasks: state.tasks.concat(nTask)};
    
        case ActionTypes.UPDATE_TASK:
            const uTask = action.payload;
            const updatedTasks = state.tasks.map(t => t.id === uTask.id ? uTask : t );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, tasks: updatedTasks};

        default:
            return state;
    }
};